import React, { useCallback } from 'react';
import { ThemeName } from '@sravni/design-system-theme';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Theme, Sun } from '@sravni/react-icons';
import { useStyles, useTheme } from '@sravni/react-utils';
import modules_8bb178ca from '../styles/ThemeSwitcher.module.less.js';

const ThemeSwitcher = React.forwardRef(({ className, onClick, ...rest }, ref) => {
    const cx = useStyles(modules_8bb178ca);
    const [theme, setTheme] = useTheme();
    const handleThemeChange = useCallback(() => {
        const themeToSet = theme === ThemeName.lager ? ThemeName.guinness : ThemeName.lager;
        onClick?.(themeToSet);
        setTheme(themeToSet);
    }, [onClick, setTheme, theme]);
    return (React.createElement(Space, { ref: ref, "data-qa": "ThemeSwitcher", className: cx(className, 'container'), onClick: handleThemeChange, ...rest },
        React.createElement(Text, null, "\u0422\u0451\u043C\u043D\u0430\u044F \u0442\u0435\u043C\u0430"),
        React.createElement(Icon, { size: 16, className: modules_8bb178ca.iconWrapper },
            React.createElement(Theme, { className: cx('icon', { bounceIn: theme === ThemeName.guinness, bounceOut: theme === ThemeName.lager }) }),
            React.createElement(Sun, { className: cx('icon', { bounceOut: theme === ThemeName.guinness, bounceIn: theme === ThemeName.lager }) }))));
});
ThemeSwitcher.displayName = 'ThemeSwitcher';

export { ThemeSwitcher };
//# sourceMappingURL=ThemeSwitcher.js.map
